import { AxiosResponse } from "axios";
import {
  axiosAuthenticated,
  uploadImageAndGetCdnUrl,
} from "../../../service/http";
import {
  CreateRestaurant,
  DeleteRestaurantImage,
  UpdateRestaurant,
  Venue,
} from "../../../model/Venue";
import { UploadImage } from "../../../service/api-response/UploadImage";
import { VenuesSuccessResponse } from "../../../service/api-response/VenuesSuccessResponse";
import { VenueTagsSuccessResponse } from "../../../service/api-response/VenueTagsSuccessResponse";

export const venueHttp = {
  getRestaurant: async (
    organizationKeyName?: string,
    id?: string
  ): Promise<Venue> => {
    const url = `/organizations/${organizationKeyName}/venues/${id}`;
    const response = await axiosAuthenticated.get<
      any,
      AxiosResponse<{ venue: Venue }>
    >(url);
    const venue = response.data.venue;
    return venue;
  },

  uploadRestaurantImage: async ({
    file,
    id,
    organizationKeyName,
  }: UploadImage) => {
    return uploadImageAndGetCdnUrl({
      file,
      id,
      organizationKeyName,
      apiRoute: "venue",
    });
  },

  uploadRestaurantLogo: async ({
    file,
    id,
    organizationKeyName,
  }: UploadImage) => {
    return uploadImageAndGetCdnUrl({
      file,
      id,
      organizationKeyName,
      apiRoute: "venue/logo",
    });
  },

  createRestaurant: async ({
    data,
    organizationKeyName,
  }: CreateRestaurant): Promise<string> => {
    const url = `/organizations/${organizationKeyName}/venues`;
    const response = await axiosAuthenticated.post<
      any,
      AxiosResponse<{ data: { id: string } }>
    >(url, data);
    return response.data.data.id;
  },

  updateRestaurant: async ({
    data,
    organizationKeyName,
    id,
  }: UpdateRestaurant) => {
    const url = `/organizations/${organizationKeyName}/venues/${id}`;
    const response = await axiosAuthenticated.put<any, AxiosResponse>(
      url,
      data
    );

    return response;
  },

  deleteRestaurantImage: async ({
    imageUrl,
    id,
    organizationKeyName,
  }: DeleteRestaurantImage) => {
    const imageUrlParam = encodeURIComponent(imageUrl);
    const url = `/organizations/${organizationKeyName}/upload/venue/${id}/${imageUrlParam}`;
    const response = await axiosAuthenticated.delete<any, AxiosResponse>(url);

    return response;
  },

  getRestaurants: async (organizationKeyName: string) => {
    const url = `/organizations/${organizationKeyName}/venues`;
    const response = await axiosAuthenticated.get<
      any,
      AxiosResponse<VenuesSuccessResponse>
    >(url);
    const venues = response.data.venues.items;
    return venues;
  },

  getRestaurantTags: async (organizationKeyName: string) => {
    const url = `/organizations/${organizationKeyName}/venue-tags`;
    const response = await axiosAuthenticated.get<
      any,
      AxiosResponse<VenueTagsSuccessResponse>
    >(url);
    const tags = response.data.tags.items;
    return tags;
  },
};
